var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile && !_vm.isSmallScreen)?_c('EbHeading',{staticClass:"eb-page-heading",attrs:{"type":"h1"}},[_vm._v("Actualités et réglementations")]):_vm._e(),_c('actualitiesReglementation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }